/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var select2: any;
namespace Nobox.Nobox {
    
    @Serenity.Decorators.registerClass()
    export class ExcelImportDialog extends NoboxEntityDialog<any, any> {
        protected form = new ExcelImportForm(this.idPrefix);
        public grid: any;

        constructor() {
            super();
        }

        protected updateTitle(): void {
            super.updateTitle();
        }

        dialogOpen() {
            super.dialogOpen();
            $(".s-Nobox-Nobox-ExcelImportDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Import Excel & CSV");
            Q.Router.replace("");
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons = [];
            buttons.push({
                title: 'Download Template',
                hint: 'Download Template',
                separator: true,
                icon: "fa-download text-green",
                onClick: () => {
                    window.open(`${Q.resolveUrl('~/upload/Template/') + 'ContactsTemplate.xlsx'}`)
                }
            });
            return buttons;
        }

        protected getDialogButtons() {
            var $this = this;
            var buttons = super.getDialogButtons();
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        ExcelImportService.ExcelImport({
                            FileName: this.form.FileName.value.Filename
                        }, response => {
                            //Q.notifyInfo(
                            //    'Inserted: ' + (response.Inserted || 0) +
                            //    ', Updated: ' + (response.Updated || 0));
                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }


                            function getColumns() {
                                return new Promise(resolve => {
                                    $.get(window.location.origin + '/Services/Lead/ImportExcel/ListColumns', resolve);
                                });
                            };

                            getColumns()
                                .then(result => {
                                    //$('#modalImportExcel').modal('show');
                                    var dlg = new Nobox.LeadExcelDialog();
                                    dlg.dialogOpen();
                                    const data = response.data;
                                    var arrTotalDropdown = [];
                                    var arrAddress = ["address", "alamat", "place"];
                                    var arrCity = ["city", "kota", "kab/kota", "kab", "kabupaten"];
                                    var arrCategory = ["category", "kategori"];
                                    var arrCountry = ["country", "negara"];
                                    var arrEmail = ["email", "mail", "gmail","e-mail"];
                                    var arrExtId = ["id", "extid", "code", "kode", "external id", "Ext Id"];
                                    var arrExtSites = ["external site","external sites","ext sites"];
                                    var arrLatitude = ["latitude"];
                                    var arrLongitude = ["longitude"];
                                    var arrLocation = ["location","lokasi"];
                                    var arrLocatedIn = ["located in"];
                                    var arrManager = ["manager","manajer"];
                                    var arrName = ["name", "full name", "title", "nama", "nama lengkap"];
                                    var arrNotes = ["note", "notes", "catatan"];
                                    var arrOpenHours = ["open hours", "open", "buka"];
                                    var arrPhone = ["phone", "phone number", "telephone", "telepon", "tlp", "no hp", "nohp", "no wa", "nowa", "nomor whatsapp", "nomor wa", "no whatsapp", "whatsapp"];
                                    var arrPhoto = ["photo", "poto", "foto", "image", "gambar"];
                                    var arrPostal = ["postal", "kode pos"];
                                    var arrRating = ["rating", 'nilai', "penilaian", "bintang"];
                                    var arrReviews = ["review", "reviews"];
                                    var arrSearch = ["search", "pencarian", "cari"];
                                    var arrState = ["state", "province", "provinsi"];
                                    var arrTool = ["tool", "alat"];
                                    var arrUrl = ["url"];
                                    var arrVatNumber = ["vat number", "nomor vat"];
                                    var arrWebsite = ["site", "website"];
                                    var arrList = ["list"];
                                    var arrAccessHash = ["access_hash", "access hash"];
                                    var arrUsername = ["username"];


                                    let keys;
                                    let head = '';
                                    let head2 = '<tr>';
                                    let body = '';
                                    var indexSelected = [];
                                    var fields = result['Values'];
                                    fields = fields.filter(yz => yz.name != "IsBlock");
                                    fields.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                                    fields.push({
                                        cid: 999,
                                        dflt_value: null,
                                        name: "List",
                                        notnull: 0,
                                        pk: 0,
                                        type: "text"
                                    })
                                    for (let i = 0; i < data.length; i++) {
                                        let count = 0;
                                        keys = Object.keys(data[i]);
                                        head += '<tr>';
                                        //keys.push("Email");
                                        //keys.push("Phone");
                                        keys.forEach((key, ind) => {
                                            if (i == 0) {
                                                if (count >= 0) {
                                                    arrTotalDropdown.push(count);
                                                    head += '<th><select class="select-field form-input" id="f' + count + '">';
                                                    head += '<option style="color: red" value="0">Not Imported</option>'
                                                    fields.forEach((field, index) => {
                                                        if (field.name == "Id" || field.name == "ListId" || field.name == "Tags" || field.name == "Unik" || field.name == "Progress" || field.name == "In" || field.name == "Up") {

                                                        } else {
                                                            head += '<option>' + field.name + '</option>'
                                                        }
                                                    })
                                                    head += '</th></select>';
                                                } else {
                                                    head += '<th></th>';
                                                }
                                                var keyFinal = key.toLowerCase();
                                                if (arrName.indexOf(keyFinal)>=0) {
                                                    indexSelected.push({ ind1: 13, ind2: ind });
                                                } else if (arrPhone.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 16, ind2: ind });
                                                } else if (arrCategory.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 2, ind2: ind });
                                                } else if (arrEmail.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 5, ind2: ind });
                                                } else if (arrAddress.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 1, ind2: ind });
                                                } else if (arrCountry.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 4, ind2: ind });
                                                } else if (arrState.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 22, ind2: ind });
                                                } else if (arrCity.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 3, ind2: ind });
                                                }else if (arrExtId.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 6, ind2: ind });
                                                }
                                                else if (arrExtSites.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 7, ind2: ind });
                                                } else if (arrLatitude.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 8, ind2: ind });
                                                } else if (arrLocation.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 10, ind2: ind });
                                                } else if (arrLocatedIn.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 9, ind2: ind });
                                                } else if (arrLongitude.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 11, ind2: ind });
                                                } else if (arrManager.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 12, ind2: ind });
                                                } else if (arrNotes.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 14, ind2: ind });
                                                } else if (arrOpenHours.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 15, ind2: ind });
                                                } else if (arrPhoto.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 17, ind2: ind });
                                                } else if (arrPostal.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 18, ind2: ind });
                                                } else if (arrRating.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 19, ind2: ind });
                                                } else if (arrReviews.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 20, ind2: ind });
                                                } else if (arrSearch.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 21, ind2: ind });
                                                } else if (arrTool.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 23, ind2: ind });
                                                } else if (arrUrl.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 24, ind2: ind });
                                                } else if (arrWebsite.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 26, ind2: ind });
                                                } else if (arrList.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 27, ind2: ind });
                                                }
                                                //else if (arrAccessHash.indexOf(keyFinal) >= 0) {
                                                //    indexSelected.push({ ind1: 1, ind2: ind });
                                                //}
                                                //else if (arrUsername.indexOf(keyFinal) >= 0) {
                                                //    indexSelected.push({ ind1: 27, ind2: ind });
                                                //}
                                                else if (arrVatNumber.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 25, ind2: ind });
                                                }
                                                head2 += '<th style="background:#005fb1; color:white;"> ' + key + '</th>';
                                            }
                                            data[i][key] == "null" ? "" : data[i][key];
                                            if (i <= 49) {
                                                if (count == 0)
                                                    body += '<tr>';
                                                body += '<td>' + data[i][key] + '</td>' == '<td>null</td>' ? '<td></td>' : '<td>' + data[i][key] + '</td>';

                                                if (count == data[i].length - 1)
                                                    body += '</tr>';
                                            }

                                            count++;
                                        });
                                        head += '</tr>';
                                    }
                                    head2 += '</tr>';
                                    var arrFilter = [null]
                                    $('#table').removeClass('hide');
                                    $('#thead1').append(head);
                                    if (indexSelected.length) {
                                        indexSelected.forEach((a, b) => {
                                            jQuery("#f" + a.ind2).find("option:eq(" + a.ind1 + ")").attr("selected", "true");
                                            arrFilter[a.ind2] = $('#f' + a.ind2).val();
                                        })
                                    }
                                    $('#thead2').append(head2);
                                    $('tbody').append(body);
                                    $('#totalData').text(`Total: ${data.length} Data`);
                                    $('.select-field').select2();
                                    arrTotalDropdown.forEach(function (r) {
                                        $('#f' + r).change(function () {
                                            arrFilter[r] = $('#f' + r).val();
                                        })
                                    })
                                    dlg.callback = (hasil) => {
                                        const filterFields = arrFilter;
                                        if (filterFields.indexOf("Name") < 0) {
                                            Q.alert("Please import 'Name' field.");
                                        } else {
                                            hasil = JSON.parse(hasil);
                                            let dataToStore = [];
                                            for (let i = 0; i < data.length; i++) {
                                                keys = Object.keys(data[i]);
                                                let dataToPush = {
                                                    "Phone": "",
                                                    "Email": "",
                                                    "ListId": hasil.ListId,
                                                    "Category": hasil.Category,
                                                    "Tags": "",
                                                    "Phone2": "",
                                                    "Rating": "",
                                                    "Reviews": "",
                                                    "OpenHours": "",
                                                    "Website": "",
                                                    "Address": "",
                                                    "Postal": "",
                                                    "Location": "",
                                                    "LocatedIn": "",
                                                    "Latitude": "",
                                                    "Longitude": "",
                                                    "Country": hasil.Country,
                                                    "State": "",
                                                    "City": "",
                                                    "Tool": "",
                                                    "Search": "",
                                                    "Url": "",
                                                    "Photo": "",
                                                    "ExtSites": "",
                                                    "In": null,
                                                    "Up": null,
                                                    "ExtId": "NotSet",
                                                    "List": ""
                                                };
                                                let x = 0
                                                keys.forEach(key => {
                                                    if (filterFields[x] != null) {
                                                        if (filterFields[x] != "0")
                                                            dataToPush[filterFields[x]] = data[i][key];
                                                    }

                                                    x++;
                                                })
                                                if (Q.isEmptyOrNull(dataToPush.Category)) {
                                                    dataToPush.Category = hasil.Category;
                                                }
                                                if (Q.isEmptyOrNull(dataToPush.Country)) {
                                                    dataToPush.Country = hasil.Country;
                                                }
                                                if (!Q.isEmptyOrNull(dataToPush["Name"]))
                                                    dataToStore.push({ Entity: dataToPush });
                                            }
                                            $(".CancelImport").addClass("disabled");

                                            var action = new ExcelBulkActionExcelBulkAction();
                                            action.done = () => {
                                                dlg.dialogClose();
                                                $this.grid.refresh();
                                            };
                                            action.execute(dataToStore);
                                        }
                                    }

                                    this.dialogClose();
                                });
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}